// CoreUI Pro source reference: /Users/guochunzhong/git/oss/coreui-pro/js/src/collapse.js
import BaseComponent from "./base_component"
import { targetElements } from "./dom"

export default class Collapse extends BaseComponent {
  static componentName = "collapse"

  constructor(element, config = {}) {
    super(element, config)
    this.syncTriggers()
  }

  show() {
    if (this.transitioning || this.element.classList.contains("show")) return
    const parent = this.parent()
    const siblings = parent
      ? [...parent.querySelectorAll(".collapse.show, .collapsing")].filter(
          (item) =>
            item !== this.element &&
            item.parentElement.closest(".collapse") === this.element.parentElement.closest(".collapse"),
        )
      : []
    if (siblings.some((item) => Collapse.getInstance(item)?.transitioning)) return
    if (this.emit("show", {}, { cancelable: true }).defaultPrevented) return
    siblings.forEach((item) => Collapse.getInstance(item)?.hide())
    this.transitioning = true
    const dimension = this.dimension()
    this.element.classList.remove("collapse")
    this.element.classList.add("collapsing")
    this.element.style[dimension] = "0px"
    this.element.offsetHeight
    this.element.style[dimension] = `${this.element[dimension === "height" ? "scrollHeight" : "scrollWidth"]}px`
    this.syncTriggers(true)
    this.afterTransition(this.element, () => {
      this.element.classList.remove("collapsing")
      this.element.classList.add("collapse", "show")
      this.element.style[dimension] = ""
      this.transitioning = false
      this.emit("shown")
    })
  }

  hide() {
    if (
      this.transitioning ||
      !this.element.classList.contains("show") ||
      this.emit("hide", {}, { cancelable: true }).defaultPrevented
    )
      return
    this.transitioning = true
    const dimension = this.dimension()
    this.element.style[dimension] = `${this.element.getBoundingClientRect()[dimension]}px`
    this.element.offsetHeight
    this.element.classList.add("collapsing")
    this.element.classList.remove("collapse", "show")
    this.element.style[dimension] = ""
    this.syncTriggers(false)
    this.afterTransition(this.element, () => {
      this.element.classList.remove("collapsing")
      this.element.classList.add("collapse")
      this.transitioning = false
      this.emit("hidden")
    })
  }

  dimension() {
    return this.element.classList.contains("collapse-horizontal") ? "width" : "height"
  }
  toggle() {
    this.element.classList.contains("show") ? this.hide() : this.show()
  }
  parent() {
    return typeof this.config.parent === "string" ? document.querySelector(this.config.parent) : this.config.parent
  }

  syncTriggers(open = this.element.classList.contains("show")) {
    this.triggers().forEach((trigger) => {
      const expanded =
        open || targetElements(trigger).some((target) => target !== this.element && target.classList.contains("show"))
      trigger.classList.toggle("collapsed", !expanded)
      trigger.setAttribute("aria-expanded", expanded)
    })
  }

  triggers() {
    return [...document.querySelectorAll('[data-coreui-toggle="collapse"]')].filter((trigger) =>
      targetElements(trigger).includes(this.element),
    )
  }

  dispose() {
    if (this.signal.aborted) return
    if (this.transitioning) {
      this.element.classList.remove("collapsing")
      this.element.classList.add("collapse")
      this.element.style[this.dimension()] = ""
    }
    this.syncTriggers()
    super.dispose()
  }
}
